import * as angular from 'angular';

class NetworkPointDetailsOperatorInfoClassificationComponentCtrl
    implements ng.IController
{
    public isCreateMode: boolean;
    public isEditMode: boolean;
    public classificationExpanded: boolean = true;
    public networkPoint: NetworkPointDto;

    public connectionPointType: ConnectionPointType[] = [
        'MARKET_TRANSITION_POINT',
        'BORDER_TRANSITION_POINT',
        'RESERVOIR',
        'GRID_ACCESS_POINT',
        'PRODUCTION',
        'BIOGAS_ENTRY',
        'OTHER_NETWORK_POINT'
    ];
    public flowDirection: Direction[] = ['ENTRY', 'EXIT'];
    public physicalUnit: PhysicalUnit[] = ['K_WH_H', 'K_WH_D', 'M3_H'];
    public methaneLevel: MethaneLevel[] = ['H_GAS', 'L_GAS'];
    public periodType: ProductPeriodType[] = [
        'YEAR',
        'QUARTER',
        'MONTH',
        'DAY',
        'INTRADAY'
    ];
    public capacityCategory: CapacityCategory[] = [
        'FZK',
        'FZK_C',
        'FZK_INC',
        'B_FZK',
        'B_FZK_1',
        'B_FZK_C',
        'BZK',
        'U_BZK',
        'U_KC',
        'DZK',
        'TVK',
        'FIRM',
        'FIRM_ADDITIONAL',
        'INTERRUPTIBLE',
        'INTERRUPTIBLE_LEVEL_1',
        'INTERRUPTIBLE_LEVEL_2',
        'INTERRUPTIBLE_LEVEL_N',
        'BACKHAUL_CAPACITY',
        'BACKHAUL_LEVEL_1',
        'BACKHAUL_LEVEL_2',
        'BACKHAUL_LEVEL_N',
        'DZK_1',
        'DZK_2',
        'DZK_3',
        'DZK_4',
        'DZK_5',
        'DZK_SH',
        'IUKCF_1',
        'INCREMENTAL_OFFER_LEVEL_1',
        'INCREMENTAL_OFFER_LEVEL_2',
        'INCREMENTAL_OFFER_LEVEL_3',
        'INCREMENTAL_OFFER_LEVEL_4',
        'INCREMENTAL_OFFER_LEVEL_5'
    ];
    public auctionSlots: number[] = [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25
    ];
    private periodTypes: any[] = [];
    private capacityCategories: any[] = [];
    public auctionSlotOrderSelect: any;

    $onInit(): void {
        if (this.isCreateMode && !this.isEditMode) {
            this.networkPoint.productTypes0 = [];
            this.addProductType(undefined);
            this.addCapacityCategory(undefined);
        } else {
            angular.forEach(this.networkPoint.productTypes0, (value, key) => {
                this.addProductType(value);
                this.changeProductType(key, value, undefined);
                this.periodTypes[key].productType = value;
            });

            angular.forEach(
                this.networkPoint.capacityCategories0,
                (value, key) => {
                    this.addCapacityCategory(value);
                    this.changeCapacityCategory(key, value, undefined);
                    this.capacityCategories[key].capacityCategory = value;
                }
            );

            if (this.networkPoint.auctionSlotOrder0) {
                angular.forEach(
                    <any>this.networkPoint.auctionSlotOrder0,
                    (value, key) => {
                        value.possibleSlots = angular.copy(this.auctionSlots);
                    }
                );
                angular.forEach(
                    this.networkPoint.auctionSlotOrder0,
                    (value, key) => {
                        this.changeAuctionSlot(
                            false,
                            key,
                            value.slot,
                            undefined
                        );
                    }
                );
            }
            if (this.networkPoint.auctionSlotOrderBundled0) {
                angular.forEach(
                    <any>this.networkPoint.auctionSlotOrderBundled0,
                    (value, key) => {
                        value.possibleSlots = angular.copy(this.auctionSlots);
                    }
                );
                angular.forEach(
                    this.networkPoint.auctionSlotOrderBundled0,
                    (value, key) => {
                        this.changeAuctionSlot(
                            true,
                            key,
                            value.slot,
                            undefined
                        );
                    }
                );
            }
        }

        if (this.isEditMode && this.networkPoint.productTypes0.length == 0) {
            this.addProductType(undefined);
        }
        if (
            this.isEditMode &&
            this.networkPoint.capacityCategories0.length == 0
        ) {
            this.addCapacityCategory(undefined);
        }
    }

    public addProductType(type: string) {
        let newPeriodType = {
            productType: type,
            possibleProductTypes: angular.copy(this.periodType)
        };
        this.periodTypes.push(newPeriodType);
        if (this.periodTypes.length > 1) {
            const index = this.periodTypes.length - 1;
            angular.forEach(this.periodTypes, (type, key) => {
                if (key != index) {
                    const delIndex = this.periodTypes[
                        index
                    ].possibleProductTypes.indexOf(type.productType);
                    if (delIndex != -1) {
                        this.periodTypes[index].possibleProductTypes.splice(
                            delIndex,
                            1
                        );
                    }
                }
            });
        }
    }

    public changeProductType(
        index: number,
        newValue: string,
        oldValue: string
    ) {
        angular.forEach(this.periodTypes, (product, key) => {
            if (key != index) {
                const delIndex = product.possibleProductTypes.indexOf(newValue);
                if (delIndex != -1) {
                    product.possibleProductTypes.splice(delIndex, 1);
                }
                if (!!oldValue) {
                    product.possibleProductTypes.push(oldValue);
                }
            }
        });
        this.networkPoint.productTypes0 = [];
        angular.forEach(this.periodTypes, (type) => {
            if (type.productType != null) {
                this.networkPoint.productTypes0.push(type.productType);
            }
        });
    }

    public removeProductType(index: number) {
        let deletedType = this.periodTypes[index].productType;
        const indexToDelete =
            this.networkPoint.productTypes0.indexOf(deletedType);
        if (indexToDelete != -1) {
            this.networkPoint.productTypes0.splice(indexToDelete, 1);
        }
        this.periodTypes.splice(index, 1);
        if (deletedType !== '') {
            angular.forEach(this.periodTypes, (type) => {
                type.possibleProductTypes.push(deletedType);
            });
        }
    }

    public addCapacityCategory(category: string) {
        let newCapacityCategory = {
            capacityCategory: category,
            possibleCapacityCategories: angular.copy(this.capacityCategory)
        };
        this.capacityCategories.push(newCapacityCategory);
        if (this.capacityCategories.length > 1) {
            const index = this.capacityCategories.length - 1;
            angular.forEach(this.capacityCategories, (type, key) => {
                if (key != index) {
                    let delIndex = this.capacityCategories[
                        index
                    ].possibleCapacityCategories.indexOf(type.capacityCategory);
                    if (delIndex != -1) {
                        this.capacityCategories[
                            index
                        ].possibleCapacityCategories.splice(delIndex, 1);
                    }
                }
            });
        }
    }

    public changeCapacityCategory(
        index: number,
        newValue: string,
        oldValue: string
    ) {
        angular.forEach(this.capacityCategories, (category, key) => {
            if (key != index) {
                const delIndex =
                    category.possibleCapacityCategories.indexOf(newValue);
                if (delIndex != -1) {
                    category.possibleCapacityCategories.splice(delIndex, 1);
                }
                if (!!oldValue) {
                    category.possibleCapacityCategories.push(oldValue);
                }
            }
        });
        this.networkPoint.capacityCategories0 = [];
        angular.forEach(this.capacityCategories, (type) => {
            if (angular.isDefined(type.capacityCategory)) {
                this.networkPoint.capacityCategories0.push(
                    type.capacityCategory
                );
            }
        });
    }

    public removeCapacityCategory(index: number) {
        let deletedType = this.capacityCategories[index].capacityCategory;
        const indexToDelete =
            this.networkPoint.capacityCategories0.indexOf(deletedType);
        if (indexToDelete != -1) {
            this.networkPoint.capacityCategories0.splice(indexToDelete, 1);
        }
        this.capacityCategories.splice(index, 1);
        if (deletedType !== '') {
            angular.forEach(this.capacityCategories, (type) => {
                type.possibleCapacityCategories.push(deletedType);
            });
        }
    }

    public syncCapacityCategories() {
        angular.forEach(
            this.networkPoint.auctionSlotOrder0,
            (auctionSlotOrder) => {
                angular.forEach(
                    auctionSlotOrder.capacityCategoriesForSlot,
                    (category) => {
                        if (
                            this.networkPoint.capacityCategories0.indexOf(
                                category
                            ) == -1
                        ) {
                            auctionSlotOrder.capacityCategoriesForSlot.splice(
                                auctionSlotOrder.capacityCategoriesForSlot.indexOf(
                                    category
                                ),
                                1
                            );
                        }
                    }
                );
            }
        );

        angular.forEach(
            this.networkPoint.auctionSlotOrderBundled0,
            (auctionSlotOrder) => {
                angular.forEach(
                    auctionSlotOrder.capacityCategoriesForSlot,
                    (category) => {
                        if (
                            this.networkPoint.capacityCategories0.indexOf(
                                category
                            ) == -1
                        ) {
                            auctionSlotOrder.capacityCategoriesForSlot.splice(
                                auctionSlotOrder.capacityCategoriesForSlot.indexOf(
                                    category
                                ),
                                1
                            );
                        }
                    }
                );
            }
        );
    }

    public changeAuctionSlot(
        bundled: boolean,
        index: number,
        newValue: number,
        oldValue: number
    ) {
        if (!bundled) {
            angular.forEach(
                <any>this.networkPoint.auctionSlotOrder0,
                (slot, key) => {
                    if (key != index) {
                        const delIndex = slot.possibleSlots.indexOf(newValue);
                        if (delIndex != -1) {
                            slot.possibleSlots.splice(delIndex, 1);
                        }
                        if (!!oldValue) {
                            slot.possibleSlots.push(oldValue);
                        }
                    }
                }
            );
        } else {
            angular.forEach(
                <any>this.networkPoint.auctionSlotOrderBundled0,
                (slot, key) => {
                    if (key != index) {
                        const delIndex = slot.possibleSlots.indexOf(newValue);
                        if (delIndex != -1) {
                            slot.possibleSlots.splice(delIndex, 1);
                        }
                        if (!!oldValue) {
                            slot.possibleSlots.push(oldValue);
                        }
                    }
                }
            );
        }
    }

    public addSlotOrder(bundled: boolean) {
        let newSlot = {
            slot: null,
            capacityCategoriesForSlot: [],
            possibleSlots: angular.copy(this.auctionSlots)
        };

        if (!bundled) {
            if (!this.networkPoint.auctionSlotOrder0) {
                this.networkPoint.auctionSlotOrder0 = [];
            } else {
                angular.forEach(this.networkPoint.auctionSlotOrder0, (slot) => {
                    if (newSlot.possibleSlots.indexOf(slot.slot) > -1) {
                        newSlot.possibleSlots.splice(
                            newSlot.possibleSlots.indexOf(slot.slot),
                            1
                        );
                    }
                });
            }
            this.networkPoint.auctionSlotOrder0.push(newSlot);
        } else {
            if (!this.networkPoint.auctionSlotOrderBundled0) {
                this.networkPoint.auctionSlotOrderBundled0 = [];
            } else {
                angular.forEach(
                    this.networkPoint.auctionSlotOrderBundled0,
                    (slot) => {
                        if (newSlot.possibleSlots.indexOf(slot.slot) > -1) {
                            newSlot.possibleSlots.splice(
                                newSlot.possibleSlots.indexOf(slot.slot),
                                1
                            );
                        }
                    }
                );
            }
            this.networkPoint.auctionSlotOrderBundled0.push(newSlot);
        }
    }

    public removeSlotOrder(bundled: boolean, index: number) {
        if (!bundled) {
            this.changeAuctionSlot(
                bundled,
                index,
                undefined,
                this.networkPoint.auctionSlotOrder0[index].slot
            );
            this.networkPoint.auctionSlotOrder0.splice(index, 1);
        } else {
            this.changeAuctionSlot(
                bundled,
                index,
                undefined,
                this.networkPoint.auctionSlotOrderBundled0[index].slot
            );
            this.networkPoint.auctionSlotOrderBundled0.splice(index, 1);
        }
    }

    public addCapacityCategoryToSlot(
        index: number,
        capacityCategory: CapacityCategory,
        bundled: boolean
    ) {
        if (!bundled) {
            if (
                this.networkPoint.auctionSlotOrder0[
                    index
                ].capacityCategoriesForSlot.indexOf(capacityCategory) == -1
            ) {
                this.networkPoint.auctionSlotOrder0[
                    index
                ].capacityCategoriesForSlot.push(capacityCategory);
            }
        } else {
            if (
                this.networkPoint.auctionSlotOrderBundled0[
                    index
                ].capacityCategoriesForSlot.indexOf(capacityCategory) == -1
            ) {
                this.networkPoint.auctionSlotOrderBundled0[
                    index
                ].capacityCategoriesForSlot.push(capacityCategory);
            }
        }

        this.auctionSlotOrderSelect = null;
    }

    public filterUsedCapacityCategoriesInAuctionSlotOrder(
        bundled: boolean,
        index: number
    ) {
        return (type: CapacityCategory) => {
            if (!bundled) {
                if (
                    this.networkPoint.auctionSlotOrder0[
                        index
                    ].capacityCategoriesForSlot.indexOf(type) != -1
                ) {
                    return false;
                }
            } else {
                if (
                    this.networkPoint.auctionSlotOrderBundled0[
                        index
                    ].capacityCategoriesForSlot.indexOf(type) != -1
                ) {
                    return false;
                }
            }
            return true;
        };
    }

    public removeCapacityCategoryFromSlot(
        index: number,
        capacityCategory: CapacityCategory,
        bundled: boolean
    ) {
        if (!bundled) {
            this.networkPoint.auctionSlotOrder0[
                index
            ].capacityCategoriesForSlot.splice(
                this.networkPoint.auctionSlotOrder0[
                    index
                ].capacityCategoriesForSlot.indexOf(capacityCategory),
                1
            );
        } else {
            this.networkPoint.auctionSlotOrderBundled0[
                index
            ].capacityCategoriesForSlot.splice(
                this.networkPoint.auctionSlotOrderBundled0[
                    index
                ].capacityCategoriesForSlot.indexOf(capacityCategory),
                1
            );
        }
    }
}

angular
    .module('app')
    .component('pkpNetworkPointDetailsOperatorInfoClassification', {
        controller: NetworkPointDetailsOperatorInfoClassificationComponentCtrl,
        template:
            require('app/network-point/network-point-details-operator-info-classification.component.html'),
        bindings: {
            form: '=',
            networkPoint: '=',
            isEditMode: '<',
            isCreateMode: '<'
        }
    });
